// Mock data for testing the flowchart component
// CORRECTED VERSION - Updated to match current database schema
// Modify the values below to test different scenarios and see how the node colors change

export const mockHomeData = {
    // Test different status values for each node
    // Available statuses: "Unknown", "No Need", "Not Ready for Work", "Needed Not Started", "25%", "50%", "75%", "Ready for Inspection", "Complete"

    // Assessment and Initial Work
    assessmentCompleted: "Complete", // "Assess Needs" - bg-green-500
    assessmentCompletedClaimedBy: "Partner Scopes", // "Assess Needs" claimed by
    crawlSpaceMuck: "50%", // "M&G Crawl Space" - bg-yellow-500
    crawlSpaceMuckClaimedBy: "Partner Scopes", // "M&G Crawl Space" claimed by
    muckGutNeeded: "Needed Not Started", // "Muck and Gut Interior" - bg-slate-400 (with 0% label)
    muckGutNeededClaimedBy: "AR Scopes", // "Muck and Gut Interior" claimed by
    roofTarpNeeded: "No Need", // "Tarp Roof" - bg-gray-300
    roofTarpNeededClaimedBy: "Partner Scopes", // "Tarp Roof" claimed by
    treeWorkNeeded: "75%", // "Tree Work" - bg-orange-500
    treeWorkNeededClaimedBy: "Partner Scopes", // "Tree Work" claimed by
    crawlSpaceInsulation: "75%", // "Insulate Crawl Space" - bg-purple-500
    crawlSpaceInsulationClaimedBy: "Partner Scopes", // "Insulate Crawl Space" claimed by
    moldRemediation: "Ready for Inspection", // "Mold Remediation" - bg-blue-500
    moldRemediationClaimedBy: "Partner Scopes", // "Mold Remediation" claimed by
    roofing: "Unknown", // "Install Roofing" - bg-cyan-200
    roofingClaimedBy: "Partner Scopes", // "Install Roofing" claimed by
    drivewayRepair: "Complete", // "Repair Driveway" - bg-green-500
    drivewayRepairClaimedBy: "Partner Scopes", // "Repair Driveway" claimed by
    miscellaneous: "Ready for Inspection", // "Misc" - bg-yellow-500
    miscellaneousClaimedBy: "Partner Scopes", // "Misc" claimed by

    // Rebuild Preparation
    rebuildPrep: "Not Ready for Work", // "Rebuild Prep" - bg-red-500
    rebuildPrepClaimedBy: "Partner Scopes", // "Rebuild Prep" claimed by
    roofingInspections503: "No Need", // "Roof Final Inspection" - bg-gray-300
    roofingInspections503ClaimedBy: "Partner Scopes", // "Roof Final Inspection" claimed by

    // Rough Work
    roughCarpentry: "50%", // "Rough Carpentry" - bg-orange-500
    roughCarpentryClaimedBy: "Partner Scopes", // "Rough Carpentry" claimed by
    electricalRoughIn: "75%", // "Rough Electrical" - bg-purple-500
    electricalRoughInClaimedBy: "Partner Scopes", // "Rough Electrical" claimed by
    mechanicalRoughIn: "Ready for Inspection", // "Rough Mechanical" - bg-blue-500
    mechanicalRoughInClaimedBy: "Partner Scopes", // "Rough Mechanical" claimed by
    plumbingRoughIn: "Complete", // "Rough Plumbing" - bg-green-500
    plumbingRoughInClaimedBy: "Partner Scopes", // "Rough Plumbing" claimed by

    // Rough Inspections
    framingInspections105: "Unknown", // "Rough Carpentry Inspection" - bg-cyan-200
    framingInspections105ClaimedBy: "Partner Scopes", // "Rough Carpentry Inspection" claimed by
    electricalInspections304: "25%", // "Rough Electrical Inspection" - bg-yellow-500
    electricalInspections304ClaimedBy: "Partner Scopes", // "Rough Electrical Inspection" claimed by
    hvacInspections401: "Not Ready for Work", // "Rough Mechanical Inspection" - bg-red-500
    hvacInspections401ClaimedBy: "Partner Scopes", // "Rough Mechanical Inspection" claimed by
    plumbingInspections202: "50%", // "Rough Plumbing / Tub Set Inspection" - bg-orange-500
    plumbingInspections202ClaimedBy: "Partner Scopes", // "Rough Plumbing / Tub Set Inspection" claimed by

    // Insulation
    insulationInstall: "75%", // "Insulation" - bg-purple-500
    insulationInstallClaimedBy: "Partner Scopes", // "Insulation" claimed by
    insulationInspections107: "Ready for Inspection", // "Insulation Inspection" - bg-blue-500
    insulationInspections107ClaimedBy: "Partner Scopes", // "Insulation Inspection" claimed by

    // Drywall
    drywallHanging: "Complete", // "Drywall Hanging" - bg-green-500
    drywallHangingClaimedBy: "Partner Scopes", // "Drywall Hanging" claimed by
    drywallInspections: "Unknown", // "Drywall Inspection" - bg-cyan-200
    drywallInspectionsClaimedBy: "Partner Scopes", // "Drywall Inspection" claimed by
    mudAndTape: "25%", // "Mud and Tape" - bg-yellow-500
    mudAndTapeClaimedBy: "Partner Scopes", // "Mud and Tape" claimed by

    // Finishing
    interiorPaint: "Not Ready for Work", // "Interior Paint" - bg-red-500
    interiorPaintClaimedBy: "Partner Scopes", // "Interior Paint" claimed by
    cabinetInstall: "50%", // "Install Cabinets" - bg-orange-500
    cabinetInstallClaimedBy: "Partner Scopes", // "Install Cabinets" claimed by
    hvac: "75%", // "HVAC Final" - bg-purple-500
    hvacClaimedBy: "Partner Scopes", // "HVAC Final" claimed by
    bathroomRebuild: "Ready for Inspection", // "Bathroom Rebuild" - bg-blue-500
    bathroomRebuildClaimedBy: "Partner Scopes", // "Bathroom Rebuild" claimed by
    counterInstall: "Complete", // "Install Counters" - bg-green-500
    counterInstallClaimedBy: "Partner Scopes", // "Install Counters" claimed by
    electrical: "Unknown", // "Electrical Fixtures" - bg-cyan-200
    electricalClaimedBy: "Partner Scopes", // "Electrical Fixtures" claimed by
    plumbing: "25%", // "Plumbing Fixtures" - bg-yellow-500
    plumbingClaimedBy: "Partner Scopes", // "Plumbing Fixtures" claimed by

    // Final Inspections
    electricalInspections305: "Not Ready for Work", // "Final Electrical Inspection" - bg-red-500
    electricalInspections305ClaimedBy: "Partner Scopes", // "Final Electrical Inspection" claimed by
    plumbingInspections204: "50%", // "Final Plumbing Inspection" - bg-orange-500
    plumbingInspections204ClaimedBy: "Partner Scopes", // "Final Plumbing Inspection" claimed by
    hvacInspections402: "75%", // "Final HVAC Inspection" - bg-purple-500
    hvacInspections402ClaimedBy: "Partner Scopes", // "Final HVAC Inspection" claimed by
    finalInspection106: "Ready for Inspection", // "Final Inspection" - bg-blue-500
    finalInspection106ClaimedBy: "Partner Scopes", // "Final Inspection" claimed by

    // Final Work
    flooringInstall: "Complete", // "Flooring Install" - bg-green-500
    flooringInstallClaimedBy: "Partner Scopes", // "Flooring Install" claimed by
    installInteriorDoors: "Unknown", // "Install Interior Doors" - bg-cyan-200
    installInteriorDoorsClaimedBy: "Partner Scopes", // "Install Interior Doors" claimed by
    exteriorDoorInstall: "25%", // "Install Exterior Doors" - bg-yellow-500
    exteriorDoorInstallClaimedBy: "Partner Scopes", // "Install Exterior Doors" claimed by
    trimInstall: "Non-AR Scope", // "Trim Install" - bg-red-500
    trimInstallClaimedBy: "Partner Scopes", // "Trim Install" claimed by

    // Equipment and Debris
    heavyEquipmentNeeded: "50%", // "Heavy Equipment / Demo" - bg-orange-500
    heavyEquipmentNeededClaimedBy: "Partner Scopes", // "Heavy Equipment / Demo" claimed by
    exteriorDebrisRemovalNeeded: "75%", // "Exterior Debris Removal" - bg-purple-500
    exteriorDebrisRemovalNeededClaimedBy: "Partner Scopes", // "Exterior Debris Removal" claimed by
    applianceInstall: "Ready for Inspection", // "Install Appliances" - bg-blue-500
    applianceInstallClaimedBy: "Partner Scopes", // "Install Appliances" claimed by
}

// Color mapping for reference:
// "Unknown" -> bg-cyan-200 (light cyan)
// "No Need" -> bg-gray-300 (light gray)
// "Not Ready for Work" -> bg-red-500 (red)
// "Needed Not Started" -> bg-slate-400 (with 0% label, color depends on claimedBy)
// "25%" -> bg-yellow-500 (yellow)
// "50%" -> bg-orange-500 (orange)
// "75%" -> bg-purple-500 (purple)
// "Ready for Inspection" -> bg-blue-500 (blue)
// "Complete" -> bg-green-500 (green)
// Any other value -> bg-pink-400 (pink)

// Instructions for testing:
// 1. Change any value in the mockHomeData object above
// 2. Save the file
// 3. The flowchart will automatically update with the new colors
// 4. Test different combinations to see how the workflow looks

